

export const getCurrentUrl = () => {
    return new Promise((resolve, reject) => {
      resolve(window.location.href);
    })
  }


// WEBPACK FOOTER //
// ./src/effects/api/base.service.tsx